import { CSV_FILE_TYPE } from 'ui-components/components/drag-drop-files/constants';
import { DragDropFiles } from 'ui-components/components/drag-drop-files/drag-drop-files';

import { useImportContext } from './import-context';
import { WorkflowSteps } from '../../../../tracking/use-workflow-tracking';

const allowedFiles = [CSV_FILE_TYPE];

/**
 * @param {object} props
 * @param {string} props.name
 * @param {string} [props.className] - Additional CSS class names
 * @returns {React.JSX.Element}
 */
export const AddCsvFile = ({ name, className }) => {
  const { setFile, initRequest, trackProcess } = useImportContext();

  const onChange = (file) => {
    setFile(file);
    trackProcess(WorkflowSteps.CSV_IMPORT_UPLOAD_FILE, {
      file: {
        name: file?.name,
        size: file?.size,
      },
    });
  };

  return <DragDropFiles allowedFiles={allowedFiles} className={className} file={initRequest.csvFile} name={name} onChange={onChange} />;
};
